import { KnownCaliSetMessageDetails, knownCaliSetMessageDetails, CaliSetCalibrationStateStatus, CaliSet, CaliSetCalibrationState } from '../../../../viewModels/printerTypes';

export const isMessageDetailKnown = (messageDetail: string | undefined): messageDetail is KnownCaliSetMessageDetails => {
    return knownCaliSetMessageDetails.includes(messageDetail as KnownCaliSetMessageDetails);
};

export function getTippyContentForCaliStatusIcon(calibrationStatus: CaliSetCalibrationStateStatus | undefined, calibrationMessage: string | undefined, calibrated: boolean) {
    if (!calibrationStatus) return calibrated ? "Calibration successful" : "Not yet calibrated";
    if (calibrationMessage && calibrationMessage === "Cancelled") return "Not yet calibrated";
    switch (calibrationStatus) {
        case 'Succeeded':
            return "Calibration successfull";
        case 'Failed':
            return "Calibration could not be completed. Please check the printer";
        case 'Error':
            return "Calibration could not be completed. Please check the printer";
        default:
            return "Not yet calibrated";
    }
}

export const injectCaliSetsWithCalibrationTimestamp = (caliSet: CaliSet) => {

    const getStateWithTimeStamp = (state: CaliSetCalibrationState | null) => {

        if (!state) {
            return null;
        }

        return {
            ...state,
            // If ColorProof sends a State, this means the subscription sends a calibration event, so we can use the current time.
            // If ColorProof sends no State, no calibration is running or CP is not sending State info, so we don't need the timestamp.
            TimeStamp: state?.TimeStamp ?? new Date().toISOString(),
        };
    }

    return {
        ...caliSet,
        State: getStateWithTimeStamp(caliSet.State),
    };
};